<template>
  <div
    :grc_placeholder="placeholder"
    :grc_labeltext="labeltext"
    :grc_labelmode="labelmode"
    :grc_labelwidth="labelwidth"
    :grc_readonly="readonly"    

    :grc_thousandsep="settings.thousandsep"
    :grc_decimalpoint="settings.decimalpoint"
    :grc_decimalplaces="settings.decimalplaces"
    :grc_currency="settings.currency"
    :grc_currpos="settings.currpos"
    :grc_textalign="settings.textalign"

    :value="component_value"
  >
    <div ref="comp_container" :class="['grccomp_container', labelmode=='table' ? 'grccomp_container_tablemode' : '']">
      <div ref="container_label" 
        :class="['grccomp_container_label', labelmode=='nolabel' ? 'grccomp_container_nolabel' : '', comp_focused ? 'grccomp_container_label_focused' : '']"
        v-bind:style="{ 'width': labelwidth }"
      >{{labeltext}}</div>
      <div ref="container_input" class="grccomp_container_input">
        <input ref="numinput" type="text" class="grc-input" inputmode="decimal"
        v-model="display_text" 
        @input="onInput" 
        @blur="onInputBlur" 
        @focus="onInputFocus($event)" 
        @keydown="onInputKeydown"
        v-bind:placeholder="placeholder"
        :readonly="readonly == 'true'"
        v-bind:style="{ 'text-align': this.settings.textalign }"
        />
      </div>
    </div>
    <GrcCompErrorBubble ref="ErrorBubble" />
  </div>
</template>

<script>

import Vue from 'vue'
import GrcCompErrorBubble from '../GrcComponents/GrcCompErrorBubble.vue'


export default {
  name: 'GrcNum',
  components:
  {
    GrcCompErrorBubble
  },
  props: {
    value: Number,
    grc_placeholder: String,
    grc_labeltext: String,
    grc_labelmode: String,
    grc_labelwidth: String,
    grc_readonly: String,    

    grc_thousandsep: String,    
    grc_decimalpoint: String,
    grc_decimalplaces: String,
    grc_currency: String,
    grc_currpos: String,
    grc_textalign: String
  },
  data () {
    return {
        component_value: 0,
        prev_component_value: 0,

        display_text: "",
        prev_display_text: "",         

        placeholder: this.grc_placeholder,
        labeltext: this.grc_labeltext,
        labelmode: this.grc_labelmode,
        labelwidth: this.grc_labelwidth,
        readonly: this.grc_readonly,

        comp_focused: false,
        settings: { thousandsep: this.grc_thousandsep, decimalpoint: this.grc_decimalpoint, decimalplaces: this.grc_decimalplaces, currency: this.grc_currency, currpos: this.grc_currpos, textalign: this.grc_textalign },

    }
  },
  watch : {
    value (pNewValue) {
      if (pNewValue !== this.prev_component_value) {
          this.prev_component_value = pNewValue;
          this.component_value = pNewValue;
          this.DisplayValue(pNewValue);
      }
    },

    display_text()
    {
        if (this.comp_focused == false) { return; }
        if (this.display_text != this.prev_display_text)
        {
            if (this.CheckText(this.display_text) == false)
            {
                this.display_text = this.prev_display_text;
            }
            else
            {
                this.prev_display_text = this.display_text;
            }
        }
    }

  },

  created: function()
  {
    if (typeof this.labelmode == "undefined")
    {
      this.labelmode = "nolabel";
    }

    var labelmodes = ["table", "above", "nolabel"];
    if (labelmodes.includes(this.labelmode) == false)
    {
      this.labelmode = "above";
    }

    if (typeof this.labelwidth == "undefined")
    {
      this.labelwidth = "";
    }

    this.ValidateSettings();

    if (typeof this.placeholder == "undefined")
    {
      this.placeholder = "";
    }

    if (typeof this.value != "undefined")
    {
      this.prev_component_value = this.value;
      this.component_value = this.value;
      this.DisplayValue(this.component_value);
    }
    

    //this.DisplayValue(this.component_value);
  },

  mounted: function()
  {
    
  },

  computed: {
  },

  methods: {

    SetLabel(pText)
    {
      this.labeltext = pText;
    },

    SetCurr(pText)
    {
      this.settings.currency = pText;
      this.DisplayValue(this.component_value);
    },

    HideError()
    {
      this.$refs.ErrorBubble.HideError();
    },

    ShowError(pText)
    {
      this.$refs.ErrorBubble.ShowError(pText);
    },

    ValidateSettings()
    {
      var thseplist = [" ", ","];
      if (thseplist.includes(this.settings.thousandsep) == false)
      {
        this.settings.thousandsep = grccomp_GetDefaults_Num().thousandsep;
      }

      var dplist = [".", ","];
      if (dplist.includes(this.settings.decimalpoint) == false)
      {
        this.settings.decimalpoint = grccomp_GetDefaults_Num().decimalpoint;
      }

      if (typeof this.settings.decimalplaces == "undefined")
      {
          this.settings.decimalplaces = grccomp_GetDefaults_Num().decimalplaces;
      }

      if (typeof this.settings.currency == "undefined")
      {
          this.settings.currency = grccomp_GetDefaults_Num().currency;
      }

      var currposlist = ["left", "right"];
      if (currposlist.includes(this.settings.currpos) == false)
      {
        this.settings.currpos = grccomp_GetDefaults_Num().currpos;
      }

      var alignlist = ["left", "right"];
      if (alignlist.includes(this.settings.textalign) == false)
      {
        this.settings.textalign = grccomp_GetDefaults_Num().textalign;
      }



    },

    DisplayValue(pNewValule)
    {
        var s = pNewValule.toFixed(parseInt(this.settings.decimalplaces));
        s = s.replace(".",this.settings.decimalpoint);
        s = this.FormatText(s);

        this.prev_display_text = s;
        this.display_text = s;
    },

    CheckText: function(pText)
    {
      var NoMinSign = pText.replace(/\-+/g, '');
      //console.log(pText+"   "+NoMinSign);
      if (pText.length - NoMinSign.length > 1) { return false; } // egynel tobb negativ elojel
      if (pText.length - NoMinSign.length == 1)
      {
          if (pText.startsWith("-") == false) { return false; }
      }
      pText = NoMinSign;
      
      var repchars = "[^0-9"+this.settings.decimalpoint+"]+";
      var regex = new RegExp(repchars, "g");
      var cv = pText.replace(regex, "");

      if (cv != pText) { return false; }
      
      var onlyNum = pText.replace(/[^0-9]+/g, '');

      if (cv.length - onlyNum.length > 1) { return false; } // egynel tobb tizedesvesszo
      
      if (cv.length - onlyNum.length == 1)
      {
          var sa = cv.split(this.settings.decimalpoint);
          if (sa[1].length > parseInt(this.settings.decimalplaces)) { return false; }
      }

      return true;
    },

    FormatText: function(pText)
    {
      var res = "";

      if (pText == null) { pText = ""; }

      var DisplayMinusSign = false;
      if (pText != "")
      {
          DisplayMinusSign = (pText.substr(0,1) == "-");
      }

      var repchars = "[^0-9"+this.settings.decimalpoint+"]+";
      var regex = new RegExp(repchars, "g");
      res = pText.replace(regex, "");

        if (this.comp_focused && (this.readonly != "true"))
        {
            if (DisplayMinusSign) { res = "-"+res; }

            if (parseFloat("0"+pText) == 0 ) { res = ""; }
            return res;
        }

        if (res != "")
        {
            var sa = res.split(this.settings.decimalpoint);
            var s1 = "";
            for(var i=0; i<sa[0].length;i++)
            {
                s1 = sa[0].substr(sa[0].length-i-1,1) + s1;
                if ( (i+1) % 3 == 0 )
                {
                    if (i<sa[0].length-1) { s1 = this.settings.thousandsep+s1; }
                }
            }

            res = s1;
            if (sa.length>1)
            {
                res = res + this.settings.decimalpoint+sa[1];
            }
        }


        if (DisplayMinusSign) { res = "-"+res; }
        
      if (this.settings.currency != "")
      {
          if (this.settings.currpos == "left") { res = this.settings.currency+" "+res; } else { res = res + " " +this.settings.currency; }
      }

      return res;
    },

    onInputBlur()
    {
      if (this.IsReadonly()) 
      {
        this.$emit('grc-blur');
        return;
      }
      
        var v = 0;
        
        var s = this.display_text.replace(this.settings.decimalpoint,".");
        if (s == "") { s = "0"; }
        v = parseFloat(s);

        var ValueChanged = (v != this.prev_component_value);

        this.component_value = v;

        this.comp_focused = false;


      if (ValueChanged)
      {
        this.$emit('input', this.component_value);
      }
      else
      {
        this.prev_component_value = this.component_value;          
        this.DisplayValue(this.component_value);          
      }

      this.$emit('grc-blur');
    },

    onInput (e) {
      //if (e.isTrusted) { return; } // ignore native event
      //this.SetText(e.target.value, false);
    },

    onInputKeydown(e)
    {
      if ((e.keyCode == 13) || (e.keyCode == 9)) {}
      else
      {
        this.$refs.ErrorBubble.HideError();
      }

      this.$emit('grc-keydown', e.keyCode);
      if (e.keyCode == 13)
      {
        this.$emit('grc-keydown-enter');
      }
    },

    onInputFocus(e)
    {
      this.comp_focused = true;
      this.DisplayValue(this.component_value);
        Vue.nextTick(function () {
            e.target.select();
        });      
      this.$emit('grc-focus');


    },

    SetFocus()
    {
      this.$refs.numinput.focus();
    },

    SetReadonly(pReadonly)
    {
      if (pReadonly == true)
      {
        this.readonly = "true";
      }
      else
      {
        this.readonly = "false";
      }
    },

    IsReadonly()
    {
      return (this.readonly == "true");
    },

    SetValue(pValue)
    {
      this.prev_component_value = pValue;
      this.component_value = pValue;
      this.DisplayValue(pValue);
      this.$emit('input', this.component_value);
    },

    GetValue()
    {
      return this.component_value;
    },

    GetText()
    {
      return this.display_text;
    },




    
  }
}
</script>

<style scoped>

</style>